import { SVGProps } from 'react'

const AirplaneCircle = (props: SVGProps<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <rect width="24" height="24" rx="12" fill="currentColor" />
      <path
        d="M10.6894 4.18697C10.9782 3.60947 11.499 3 12.3105 3C13.1221 3 13.6429 3.6105 13.9317 4.18697C14.2297 4.78406 14.373 5.50697 14.373 6.09375V9.90009L19.7046 12.5659C19.9618 12.6943 20.1781 12.8918 20.3293 13.1362C20.4804 13.3806 20.5605 13.6624 20.5605 13.9498V15.375C20.5605 15.4498 20.5442 15.5238 20.5127 15.5917C20.4812 15.6596 20.4353 15.7198 20.3782 15.7682C20.3211 15.8166 20.2541 15.8519 20.182 15.8718C20.1098 15.8917 20.0342 15.8957 19.9604 15.8834L14.2813 14.9367L13.8945 17.2601L15.2537 18.6193C15.326 18.6914 15.3753 18.7834 15.3953 18.8835C15.4152 18.9837 15.405 19.0875 15.3659 19.1818C15.3268 19.2762 15.2606 19.3568 15.1756 19.4134C15.0907 19.47 14.9908 19.5002 14.8887 19.5H9.73242C9.63031 19.5002 9.53044 19.47 9.44547 19.4134C9.36051 19.3568 9.29428 19.2762 9.25518 19.1818C9.21607 19.0875 9.20586 18.9837 9.22583 18.8835C9.2458 18.7834 9.29506 18.6914 9.36736 18.6193L10.7276 17.2601L10.3398 14.9367L4.66073 15.8834C4.5869 15.8957 4.51128 15.8917 4.43912 15.8718C4.36697 15.8519 4.30001 15.8166 4.2429 15.7682C4.18578 15.7198 4.13989 15.6596 4.1084 15.5917C4.07691 15.5238 4.06058 15.4498 4.06055 15.375V13.9498C4.06056 13.6624 4.14065 13.3806 4.29183 13.1362C4.44302 12.8918 4.65933 12.6943 4.91648 12.5659L10.248 9.90009V6.09375C10.248 5.508 10.3924 4.78303 10.6894 4.18697Z"
        fill="#272727"
      />
    </svg>
  )
}

export default AirplaneCircle
